(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
    key: "AIzaSyAp6sq3A4qqJPywjNdov35pXkSPiD7Yi_s",
});


let center;
if (($('.dealer-map #map')).length) {
    center = { lat: parseFloat(citymap[0].lat_long.split(', ')[0]), lng: parseFloat(citymap[0].lat_long.split(', ')[1]) };
}

let mapCenter = center;
let map;
let map_mobile;

let counterMap = 0;
let page = 0;

let filter_country = 'All';
let filter_input = '';

let markersD = {};
let markersM = {};

let currentInfoWindow_D = null;
let currentInfoWindow_M = null;

$(document).ready(function() {

    $('.paginate.custom').each(function() {
        initializePagination($(this));
    });
    
    if (($('.dealer-map #map')).length) {
        if (citymap.length > 0) {
            for (const city in citymap) {
                counterMap++;
                page = Math.floor((counterMap - 1) / 5) + 1;

                let storeType = '';

                if (citymap[city].store_type == 'RETURN') {
                    storeType = 'Return';
                }
                else if (citymap[city].store_type == 'REPAIR') {
                    storeType = 'Repair';
                }
                else if (citymap[city].store_type == 'SALES') {
                    storeType = 'Sales';
                }
                else if (citymap[city].store_type == 'RETURN + REPAIR') {
                    storeType = 'Return & Repair';
                }
                else if (citymap[city].store_type == 'RETURN + SALES') {
                    storeType = 'Return & Sales';
                }
                else if (citymap[city].store_type == 'REPAIR + SALES') {
                    storeType = 'Repair & Sales';
                }
                else if (citymap[city].store_type == 'RETURN + REPAIR + SALES') {
                    storeType = 'Return, Repair, & Sales';
                }
                else {
                    storeType = '';
                }

                let products = citymap[city].products ? ' | ' + citymap[city].products : '';
    
                let append = '<div class="location" data-page="'+page+'" data-lat="'+parseFloat(citymap[city].lat_long.split(', ')[0])+'" data-lng="'+parseFloat(citymap[city].lat_long.split(', ')[1])+'" data-country="'+citymap[city].country+'" data-type="'+citymap[city].type+'" data-address="'+citymap[city].address+'" data-contact="'+citymap[city].contact+'" data-title="'+citymap[city].title+'">'+
                                '<p class="location-name">'+counterMap+'. '+citymap[city].title+'</p>'+
                                '<p class="location-details"><span><span>Adress:</span> '+citymap[city].address+'</span></p>'+
                                '<p class="location-details"><span><span>Contact:</span> '+citymap[city].contact+'</span></p>'+
                                '<p class="location-details"><span><span>Store Type:</span> '+storeType+products+'</span></p>'+
                             '</div>';
    
                $('.locations').append(append);
            }
    
            locPaginate();
        }

        let defaultMarker = {
                url: 'https://cdn.shopify.com/s/files/1/0755/0196/1455/files/default.png?v=1756386983',
                scaledSize: { width: 35, height: 46 },
                anchor: { x: 17, y: 46 }
            };
    
        async function initMap() {
            const { Map } = await google.maps.importLibrary("maps");
        
            map = new Map(document.getElementById("map"), {
                center: mapCenter,
                zoom: 4,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false
            });
        
            map_mobile = new Map(document.getElementById("map-mobile"), {
                center: mapCenter,
                zoom: 4,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false
            });
    
            for (const city in citymap) {
                let center = {
                    lat: parseFloat(citymap[city].lat_long.split(', ')[0]),
                    lng: parseFloat(citymap[city].lat_long.split(', ')[1])
                };

                if (citymap[city].store_type == 'RETURN') {
                    defaultMarker = {
                        url: 'https://cdn.shopify.com/s/files/1/0755/0196/1455/files/return.png?v=1756386983',
                        scaledSize: { width: 35, height: 46 },
                        anchor: { x: 17, y: 46 }
                    };
                }
                else if (citymap[city].store_type == 'REPAIR') {
                    defaultMarker = {
                        url: 'https://cdn.shopify.com/s/files/1/0755/0196/1455/files/repair.png?v=1756386983',
                        scaledSize: { width: 35, height: 46 },
                        anchor: { x: 17, y: 46 }
                    };
                }
                else if (citymap[city].store_type == 'SALES') {
                    defaultMarker = {
                        url: 'https://cdn.shopify.com/s/files/1/0755/0196/1455/files/sales.png?v=1756386983',
                        scaledSize: { width: 35, height: 46 },
                        anchor: { x: 17, y: 46 }
                    };
                }
                else if (citymap[city].store_type == 'RETURN + REPAIR') {
                    defaultMarker = {
                        url: 'https://cdn.shopify.com/s/files/1/0755/0196/1455/files/return_repair.png?v=1756386982',
                        scaledSize: { width: 35, height: 46 },
                        anchor: { x: 17, y: 46 }
                    };
                }
                else if (citymap[city].store_type == 'RETURN + SALES') {
                    defaultMarker = {
                        url: 'https://cdn.shopify.com/s/files/1/0755/0196/1455/files/return_sales.png?v=1756386983',
                        scaledSize: { width: 35, height: 46 },
                        anchor: { x: 17, y: 46 }
                    };
                }
                else if (citymap[city].store_type == 'REPAIR + SALES') {
                    defaultMarker = {
                        url: 'https://cdn.shopify.com/s/files/1/0755/0196/1455/files/repair_sales.png?v=1756386983',
                        scaledSize: { width: 35, height: 46 },
                        anchor: { x: 17, y: 46 }
                    };
                }
                else if (citymap[city].store_type == 'RETURN + REPAIR + SALES') {
                    defaultMarker = {
                        url: 'https://cdn.shopify.com/s/files/1/0755/0196/1455/files/return_repair_sales.png?v=1756386982',
                        scaledSize: { width: 35, height: 46 },
                        anchor: { x: 17, y: 46 }
                    };
                }
                else {
                    defaultMarker = {
                        url: 'https://cdn.shopify.com/s/files/1/0755/0196/1455/files/default.png?v=1756386983',
                        scaledSize: { width: 35, height: 46 },
                        anchor: { x: 17, y: 46 }
                    };
                }
    
                const markerD = new google.maps.Marker({
                    position: center,
                    map: map,
                    icon: defaultMarker
                });
        
                const markerM = new google.maps.Marker({
                    position: center,
                    map: map_mobile,
                    icon: defaultMarker
                });

                const contentString = `
                    <div class="map-info">
                        <div class="map-image">
                            <img src="${citymap[city].image}">
                        </div>
                        <div class="map-more">
                            <p class="body-xs mt-medium f-black">${citymap[city].title}</p>
                            <p class="map-details"><span><span>Adress:</span> ${citymap[city].address}</span></p>
                            <p class="map-details"><span><span>Contact:</span> ${citymap[city].contact}</span></p>
                        </div>
                    </div>
                `;

                markerD.infowindow = new google.maps.InfoWindow({
                    content: contentString
                });      
                markerD.addListener("click", () => {
                    if (currentInfoWindow_D)
                        currentInfoWindow_D.close();
    

                    markerD.infowindow.open(map, markerD);
                    currentInfoWindow_D = markerD.infowindow;
                });

                markersD[`${center.lat},${center.lng}`] = markerD;
            }
        }
    
        initMap();
    }

    if ($('.grid-slider').length) {
        $('.grid-slider .owl-carousel').each(function () {
            let $carousel = $(this);

            $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: false,
                loop: true,
                smartSpeed: 800,
                margin: 20,
                stagePadding: 30
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

});

$(document).on('click', '.location', function() {;
    const lat = $(this).data('lat');
    const lng = $(this).data('lng');
    const markerKey = `${lat},${lng}`;

    map.setZoom(15);
    map.panTo({ lat, lng });
    map_mobile.setZoom(15);
    map_mobile.panTo({ lat, lng });

    if (window.innerWidth < 1280) {
        /* if (markersM[markerKey]) {
            google.maps.event.trigger(markersM[markerKey], 'click');
        } */

        let title = $(this).data('title');
        let address = $(this).data('address');
        let contact = $(this).data('contact');

        $('.map-wrapper .map-title').html(title);
        $('.map-wrapper .data.address').html(address);
        $('.map-wrapper .data.contact').html(contact);

        $('.map-wrapper').css('display', 'flex');

        $('body').css('overflow-y', 'hidden');
    }
    else {
        if (markersD[markerKey]) {
            google.maps.event.trigger(markersD[markerKey], 'click');
        }
    }
});

$('.map-wrapper .map-header, .map-wrapper .overlay').on('click', function() {
    $('.map-wrapper').hide();
    $('body').css('overflow-y', 'visible');
});

$('select[name="retail-country"]').on('change', function() {
    filter_country = $(this).val();

    filterLocation(filter_country, filter_input);
});
$('.filter-input .search-btn').on('click', function() {
    filter_input = $('input[name="search-address"]').val();

    filterLocation(filter_country, filter_input);
})
$('.filter-input input').on('keyup', function() {
    filter_input = $('input[name="search-address"]').val();

    filterLocation(filter_country, filter_input);
})

function filterLocation(country, location) {

    let show = citymap;

    if (normalize(country) !== 'all') {
        show = show.filter(x => 
            normalize(x.country).includes(normalize(country))
        );
    }

    if (normalize(location) !== '') {
        show = show.filter(x => 
            normalize(x.address).includes(normalize(location)) || 
            normalize(x.title).includes(normalize(location))
        );
    }

    if (show.length > 0) {
        $('.locations').html('');
        counterMap = 0;
        
        for (let city in show) {
            counterMap ++;
            page = Math.floor((counterMap - 1) / 5) + 1;

            let storeType = '';

            if (show[city].store_type == 'RETURN') {
                storeType = 'Return';
            }
            else if (show[city].store_type == 'REPAIR') {
                storeType = 'Repair';
            }
            else if (show[city].store_type == 'SALES') {
                storeType = 'Sales';
            }
            else if (show[city].store_type == 'RETURN + REPAIR') {
                storeType = 'Return & Repair';
            }
            else if (show[city].store_type == 'RETURN + SALES') {
                storeType = 'Return & Sales';
            }
            else if (show[city].store_type == 'REPAIR + SALES') {
                storeType = 'Repair & Sales';
            }
            else if (show[city].store_type == 'RETURN + REPAIR + SALES') {
                storeType = 'Return, Repair, & Sales';
            }
            else {
                storeType = '';
            }

            let append = '<div class="location" data-page="'+page+'" data-lat="'+parseFloat(show[city].lat_long.split(', ')[0])+'" data-lng="'+parseFloat(show[city].lat_long.split(', ')[1])+'" data-country="'+show[city].country+'" data-type="'+show[city].type+'" data-address="'+show[city].address+'" data-contact="'+show[city].contact+'" data-title="'+show[city].title+'">'+
                                '<p class="location-name">'+counterMap+'. '+show[city].title+'</p>'+
                                '<p class="location-details"><span><span>Adress:</span> '+show[city].address+'</span></p>'+
                                '<p class="location-details"><span><span>Contact:</span> '+show[city].contact+'</span></p>'+
                                '<p class="location-details"><span><span>Store Type:</span> '+storeType+'</span></p>'+
                            '</div>';

            $('.locations').append(append);
        }

        locPaginate();

        map.setZoom(15);
        map.panTo({
            lat : parseFloat(show[0].lat_long.split(', ')[0]),
            lng : parseFloat(show[0].lat_long.split(', ')[1])
        });
    }
    else {
        $('.locations').html('<div class="no-found">No store found.</div>');
    }
}

function htmlDecode(str) {
    // Attempt DOMParser decoding first
    if (typeof DOMParser !== "undefined") {
        let doc = new DOMParser().parseFromString(str, "text/html");
        return doc.documentElement.textContent;
    }

    // Fallback manual decoding (for numeric + common named entities)
    return str
        .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(code))
        .replace(/&quot;/g, '"')
        .replace(/&apos;/g, "'")
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>');
}

function normalize(str) {
    return htmlDecode(str)
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, '')     // remove accents
        .replace(/['’`‘]/g, '')              // remove apostrophes
        .replace(/[^\w\s]/g, '')             // remove remaining symbols
        .toLowerCase();
}

function locPaginate() {
    if (window.innerWidth < 1280) {
        if (counterMap > 5) {
            const itemsPerPage = 5;
            const totalItems = counterMap;
            const totalPages = Math.floor(totalItems / itemsPerPage);
            const remainder = totalItems % itemsPerPage;
    
            let pageTotal = totalPages;
            if (remainder !== 0) {
                pageTotal += 1;
            }
    
            const $pagination = $('<div class="paginate custom d-lg-none d-md-flex d-sm-flex" data-total="' + pageTotal + '"></div>');
    
            const $leftArrow = $('<a class="page disable" href="javascript:void(0)"><i class="fa-solid fa-chevron-left"></i></a>');
            $pagination.append($leftArrow);
    
            for (let i = 1; i <= pageTotal; i++) {
                const $pageLink = $('<a class="page' + (i === 1 ? ' active' : '') + '" href="javascript:void(0)" data-i="' + i + '">' + i + '</a>');
                $pagination.append($pageLink);
            }
    
            const $rightArrow = $('<a class="page" href="javascript:void(0)" data-i="' + (pageTotal) + '"><i class="fa-solid fa-chevron-right"></i></a>');
            $pagination.append($rightArrow);
    
            $('.dealer-map .locations').append($pagination);
            initializePagination($($pagination));
        }
    }
}

function updatePagination($pagination, currentPage, totalPages) {

    $pagination.empty();

    $pagination.append(`
        <a class="page ${currentPage === 1 ? 'disable' : ''}" href="javascript:void(0)" data-action="prev">
            <i class="fa-solid fa-chevron-left"></i>
        </a>
    `);

    let pageNumbers = '';

    if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers += `<a class="page ${i === currentPage ? 'active' : ''}" href="javascript:void(0)" data-i="${i}">${i}</a>`;
        }
    } else {
        const maxPagesToShow = 2;
        const startPage = Math.max(2, currentPage - maxPagesToShow);
        const endPage = Math.min(totalPages - 1, currentPage + maxPagesToShow);

        pageNumbers += `<a class="page ${currentPage === 1 ? 'active' : ''}" href="javascript:void(0)" data-i="1">1</a>`;

        if (startPage > 2) {
            pageNumbers += '<a class="page disable" href="javascript:void(0)">…</a>';
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers += `<a class="page ${i === currentPage ? 'active' : ''}" href="javascript:void(0)" data-i="${i}">${i}</a>`;
        }

        if (endPage < totalPages - 1) {
            pageNumbers += '<a class="page disable" href="javascript:void(0)">…</a>';
        }

        pageNumbers += `<a class="page ${currentPage === totalPages ? 'active' : ''}" href="javascript:void(0)" data-i="${totalPages}">${totalPages}</a>`;
    }

    $pagination.append(pageNumbers);

    $pagination.append(`
        <a class="page ${currentPage === totalPages ? 'disable' : ''}" href="javascript:void(0)" data-action="next">
            <i class="fa-solid fa-chevron-right"></i>
        </a>
    `);

    const $customRow = $pagination.parent();
    $customRow.find('[data-page]').hide();
    $customRow.find(`[data-page="${currentPage}"]`).show();
}

function initializePagination($pagination) {
    const totalPages = $pagination.data('total');
    let currentPage = 1;

    updatePagination($pagination, currentPage, totalPages);

    $pagination.on('click', '.page[data-i]', function() {
        const newPage = $(this).data('i');
        if (newPage && newPage !== currentPage) {

            $('html, body').animate({
                scrollTop: $pagination.closest('.row').offset().top - 400
            }, 0);

            currentPage = newPage;
            updatePagination($pagination, currentPage, totalPages);
        }
    });

    $pagination.on('click', '[data-action="prev"]', function() {
        if (currentPage > 1) {

            $('html, body').animate({
                scrollTop: $pagination.closest('.row').offset().top - 400
            }, 0);

            currentPage--;
            updatePagination($pagination, currentPage, totalPages);
        }
    });

    $pagination.on('click', '[data-action="next"]', function() {
        if (currentPage < totalPages) {

            $('html, body').animate({
                scrollTop: $pagination.closest('.row').offset().top - 400
            }, 0);

            currentPage++;
            updatePagination($pagination, currentPage, totalPages);
        }
    });
}

(function($){
    $.fn.dragScroll = function() {
        return this.each(function() {
        let isDown = false;
        let startX, scrollLeft;
        const el = $(this);

        el.css('cursor', 'grab');

        el.on('mousedown', function(e) {
            isDown = true;
            el.addClass('dragging').css('cursor', 'grabbing');
            startX = e.pageX || e.originalEvent.touches[0].pageX;
            scrollLeft = el.scrollLeft();
            e.preventDefault();
        });

        $(window).on('mouseup', function() {
            isDown = false;
            el.removeClass('dragging').css('cursor', 'grab');
        });

        $(window).on('mousemove', function(e) {
            if (!isDown) return;
                let x = e.pageX || e.originalEvent.touches[0].pageX;
                let walk = (x - startX) * 1.5; // multiplier = scroll speed
                el.scrollLeft(scrollLeft - walk);
            });
        });
    };
})(jQuery);

$('.product-comparison .col-items').dragScroll();

$('.file-download .btn').on('click', function() {
    let wrapper = $(this).parent();

    wrapper.find('a').fadeIn();
    
    $(this).hide();
});